import axios from 'axios';
import {useState, useEffect, useCallback, useRef} from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import Loading from '../components/common/Loading';
import Error from '../components/common/Error';
import LoadListList from '../components/rts/LoadList/LoadListList';
import LoadListMap from '../components/rts/LoadList/LoadListMap';
import LoadListFilter from '../components/rts/LoadList/LoadListFilter';
import LoadListMode from '../components/rts/LoadList/LoadListMode';

import { useSessionContext } from '../contexts/SessionContext';


export default function LoadListPage( props ) {
    //console.debug("RTS Break LoadListPage");

    const {curFilter, user, sessionCustomer, userAuthToken, apiRoot, userLogOut} = useSessionContext();

    const [isLoading, setIsLoading] = useState(true);
    const [hasError, setHasError] = useState(false);

    const [mode, setMode] = useState(0);
    const [data, setData] = useState([]);
    
    const [filter, setFilter] = useState();
    const [showFilter, setShowFilter] = useState(true);
    const ref = useRef(null);
    

    const fetchData = useCallback((pFilter) => {
        setIsLoading(true);

        let apiURL = apiRoot + "/LoadList/GetLoadList";
        axios
        .post(
            apiURL,
            pFilter, 
            {headers:{'Authorization': 'Bearer ' + userAuthToken.token }}
        )
        .then(response => {
            if (response.data) {
                setData(response.data);
                setIsLoading(false);
                setHasError(false);
            }
            else{
                setIsLoading(false);
                setHasError(true);
            }
        })
        .catch(error => {
            setIsLoading(false);

            if(error.status === 401){
                userLogOut();
            }
            else{
                setHasError(true);
                console.log("RTS Data Error", error);
            }
        });
    },[apiRoot, userAuthToken.token, userLogOut]);


    useEffect(() => {
        props.setIsModalFx(false);
        if(curFilter != null && curFilter.key === 'LoadListPage'){
            setFilter(curFilter.filter);
            fetchData(curFilter.filter);
        }
        else{
            setFilter({ User:user, 
                        Status:[1,25,50],
                        Customer:sessionCustomer.customer,
                        Orders:[], 
                        Projects:[], 
                        Products:[], 
                        ReelTypes:[],
                        Reels:[],
                        LengthOperator:">=",
                        Length:0,
                        NamedLocations:[],
                        Crews:[],
                        Trackers:[],
                        ShipDateOperator:">=",
                        ShipDate:null,
                        Pinned:-1,
                        Locked:-1,
                        DaysStationaryOperator:">=",
                        DaysStationary:0,
                        SortBy:0
                    });

            fetchData({ User:user, 
                        Status:[1,25,50],
                        Customer:sessionCustomer.customer,
                        Orders:[], 
                        Projects:[], 
                        Products:[], 
                        ReelTypes:[],
                        Reels:[],
                        LengthOperator:">=",
                        Length:0,
                        NamedLocations:[],
                        Crews:[],
                        Trackers:[],
                        ShipDateOperator:">=",
                        ShipDate:null,
                        Pinned:-1,
                        Locked:-1,
                        DaysStationaryOperator:">=",
                        DaysStationary:0,
                        SortBy:0
                    });

        }
    }, [props, user, sessionCustomer, curFilter, fetchData]); 


    function scrollToTop(e){
        ref.current.scrollIntoView();
    }
    
    
    function forceRefresh(e){
        fetchData(filter);
    }


    function setModeVal(val){
        setMode(val);

        if(val===1){
            setShowFilter(false);
        }
        else{
            setShowFilter(true);
        }

    }


    // useEffect(() => {
    //     if(!isLoading){
    //         let viewportHeight = window.innerHeight;
    //         let elementTop = document.getElementById('contentBox').getBoundingClientRect().top;
    //         let availableHeightBelowElement = (viewportHeight - elementTop) - 100;
    //     }
    // },[showFilter]);       

    
    if(hasError){
        return(
            <Error />
        );
    }


    if(isLoading){
        return(
            <Loading />
        );
    }


    return(
        <Box id="pageBox">
            <Box id="filterBox">
                <LoadListFilter filter={filter} setFilterFx={setFilter} showFilter={showFilter} setShowFilterFx={setShowFilter} /> 
            </Box>
            <Box id="modeBox" ref={ref} >
                <LoadListMode data={data} mode={mode} modeFx={setModeVal} reelCount={data===null?0:data.length} forceRefreshFx={forceRefresh} />            
            </Box>            
            <Box id="contentBox">
                {mode===-1?<Box justifyContent={"center"} alignItems={"center"} display={"flex"}><Typography variant='h4'>No Records Found</Typography></Box>:""}
                {mode===0?<LoadListList data={data} user={user} scrollToTopFx={scrollToTop} />:""}
                {mode===1?<LoadListMap data={data} user={user} showFilter={showFilter} />:""}
            </Box> 
        </Box>
    );
}

